// extracted by mini-css-extract-plugin
module.exports = {"itineraryContainer":"ItinerarySection_itineraryContainer__Oucju","schedule":"ItinerarySection_schedule__e7_Ay"};